// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FAQSection_wrapper__OIafk","item":"FAQSection_item__m5RMJ"};